import { useAccessControl } from '@/hooks';
import { AccessControlAction, ACTIONS_ALLOWED_USER_IDS } from '@/constants';
import { selectUserAboutData, useAppSelector } from '@/store';
import { ACTIONS_REGISTRY, type ActionDefinition } from './actionsRegistry';

export const useVisibleActions = (): ActionDefinition[] => {
  const isGlobalAdmin = useAccessControl(AccessControlAction.GLOBAL_ADMIN_ONLY);
  const userAboutData = useAppSelector(selectUserAboutData);
  const userId = userAboutData?.userId;
  const isAllowedUser = !!userId && ACTIONS_ALLOWED_USER_IDS.includes(userId);

  return ACTIONS_REGISTRY.filter((action) => {
    if (isGlobalAdmin || isAllowedUser) return true;
    return !!userId && !!action.allowedUserIds?.includes(userId);
  });
};
